var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExpandHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_expand_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component1-Copy-2",
    transform: "translate(-990.000000, -784.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_expand_hover",
    transform: "translate(990.000000, 784.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5697B7",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4113019,9.71913153 C14.0253922,9.32196615 13.3984424,9.32326967 13.0159907,9.71687622 L12.6965599,10.0456238 C12.3118605,10.4415436 12.3150161,11.087412 12.6932791,11.4775576 L16.869474,15.7849424 C17.2523614,16.1798578 17.2477369,16.824912 16.869474,17.2150576 L12.6932791,21.5224424 C12.3103916,21.9173578 12.3141082,22.5607697 12.6965599,22.9543762 L13.0159907,23.2831238 C13.4006901,23.6790436 14.0256832,23.6777344 14.4113019,23.2808685 L20.3012487,17.2191315 C20.6871584,16.8219662 20.6868674,16.1777344 20.3012487,15.7808685 L14.4113019,9.71913153 Z",
    id: "Shape",
    fill: "#E5E5E5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandHover);
export default __webpack_public_path__ + "static/media/icon_expand_hover.50a1dc3df747c148815d994a3e8f1d89.svg";
export { ForwardRef as ReactComponent };